module.exports = __webpack_public_path__ + "img/2010 winteressen 034.731109c0.jpg";